import * as React from 'react';

// Components
import AccessibleSpan from '../AccessibleSpan';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Constants
import { config as platformConfigs } from '@shopee-user/platform';
import { constants } from '@shopee-user/business-customization-logic';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

// Styling
import styles from './style.scss';

export default function SignupContactUsMessage({
  isEmail,
  webViewNavigateToUrl,
}: {
  isEmail: boolean;
  webViewNavigateToUrl: WithUserWebViewProps['webViewNavigateToUrl'];
}) {
  const I18n = useTranslation();

  return (
    <div className={styles.description}>
      {I18n.tNode(
        isEmail
          ? 'msg_auth_email_already_registered_contact_us'
          : 'msg_auth_number_already_registered_contact_us',
        {
          context: platformConfigs.BUSINESS_TARGET,
          contact_us: constants.AUTHENTICATE_CONTACT_US_LINK ? (
            <AccessibleSpan
              className={styles.link}
              onClick={() =>
                webViewNavigateToUrl(constants.AUTHENTICATE_CONTACT_US_LINK)
              }
            >
              {I18n.t('label_auth_contact_us')}
            </AccessibleSpan>
          ) : (
            <span>{I18n.t('label_auth_contact_us')}</span>
          ),
        }
      )}
    </div>
  );
}
